import React, { FC } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
//components
import LinkedItemCard from '../components/successor-card/link-item-card';
// mui components
import { Grid } from '@mui/material';
// types
import { ILinkedItem } from '../types';
import { LagTypeEnum } from 'redux-store/api/company';
// styles
import { linkedItemsStyles } from './styles';

interface IProps {
  isItemCompleted: boolean;
  lagType: LagTypeEnum;
}

const LinkedSection: FC<IProps> = ({ isItemCompleted, lagType }) => {
  const form = useFormContext();

  const { fields, update, remove } = useFieldArray({
    control: form.control,
    name: 'linkedItems',
  });

  return (
    <Grid sx={linkedItemsStyles.container}>
      <Grid sx={linkedItemsStyles.tableContainer}>
        <Grid sx={linkedItemsStyles.tableHeader}>
          <Grid sx={linkedItemsStyles.name}>Item name</Grid>
          <Grid sx={linkedItemsStyles.lagDays}>Lag days</Grid>
          <Grid sx={linkedItemsStyles.date}>Start date</Grid>
          <Grid sx={linkedItemsStyles.date}>End date</Grid>
          {!isItemCompleted && <Grid sx={linkedItemsStyles.actions}>Actions</Grid>}
        </Grid>

        {(fields as ILinkedItem[]).map((field, index) => (
          <LinkedItemCard
            field={field}
            index={index}
            update={update}
            remove={remove}
            lagType={lagType}
            key={field?.id}
            showAction={!isItemCompleted}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default LinkedSection;
